// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newdraganddrop_schedule video {
  width: 200px;
}

.newdraganddrop_schedule .scroll_video_draganddrop {
  overflow: scroll;
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
}
.newdraganddrop_schedule .videos .imgae {
  width: 65px !important;
  height: 65px !important;
  object-fit: contain;
}
.newdraganddrop_schedule .board .imgae {
  width: 65px !important;
  height: 65px !important;
  object-fit: contain;
}

.newdraganddrop_schedule .next_previous button {
  font-size: 22px;
  padding: 10px;
}
.newdraganddrop_schedule .next_previous button.next-11 {
  border-left: 1px solid rgb(229, 229, 234);
}
.newdraganddrop_schedule .react-select__indicator svg {
  display: none !important;
}
.newdraganddrop_schedule
  .react-select-container.form-select.css-b62m3t-container {
  border: 1px solid rgb(229, 229, 234) !important;
}

.newdraganddrop_schedule .DatePicker {
  height: 52px;
}
/* .newdraganddrop_schedule i.fa.fa-calendar-o {
  position: absolute;
  z-index: 1;
  right: 37%;
  top: 21%;
} */
/* .newdraganddrop_schedule .react-datepicker-popper {
  position: absolute;
  inset: 0px auto auto 0px;
  transform: translate3d(90%, 30%, 0px) !important;
} */

/* Style for the dropdown container */
.editdropdowntest {
  position: relative;
  display: inline-block;
  z-index: 9;
}

/* Style for the dropdown button */
.editdropdowntest-button {
  /* background-color:  rgb(240, 240, 240) ; */
  color: #000000;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

/* Style for the dropdown menu */
.editdropdowntest-menu {
  display: none;
  left: 25px;
  top: 10px;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 100px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Show the dropdown menu when the button is clicked */
.editdropdowntest:hover .editdropdowntest-menu {
  display: block;
}

/* Style for dropdown menu items */
.editdropdowntest-menu a {
  color: black;
  padding: 5px;
  text-decoration: none;
  display: block;
}

/* Highlight dropdown menu items on hover */
.editdropdowntest-menu a:hover {
  background-color: #f1f1f1;
  padding: 5px;
}

/* Style for the dropdown container */
.editdropdownpage {
  position: relative;
  display: inline-block;
}

/* Style for the dropdown button */
.editdropdownpage-button {
  /* background-color:  rgb(240, 240, 240) ; */
  color: #000000;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

/* Style for the dropdown menu */
.editdropdownpage-menu {
  display: none;
  left: -93px;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 100%;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Show the dropdown menu when the button is clicked */
.editdropdownpage:hover .editdropdownpage-menu {
  display: block;
}

/* Style for dropdown menu items */
.editdropdownpage-menu a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Highlight dropdown menu items on hover */
.editdropdownpage-menu a:hover {
  background-color: #f1f1f1;
}

.commonActionPaddingcommonActionPadding {
  padding: 5px;
}

.commonActionPaddingcommonActionPadding:hover {
  background-color: #f1f1f1;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Video/Video_Management/EditManageCalendarschedule.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,YAAY;AACd;AACA;;;;;GAKG;AACH;;;;GAIG;;AAEH,qCAAqC;AACrC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,4CAA4C;EAC5C,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,UAAU;AACZ;;AAEA,sDAAsD;AACtD;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,4CAA4C;EAC5C,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,+CAA+C;EAC/C,UAAU;AACZ;;AAEA,sDAAsD;AACtD;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".newdraganddrop_schedule video {\n  width: 200px;\n}\n\n.newdraganddrop_schedule .scroll_video_draganddrop {\n  overflow: scroll;\n  max-height: 400px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.newdraganddrop_schedule .videos .imgae {\n  width: 65px !important;\n  height: 65px !important;\n  object-fit: contain;\n}\n.newdraganddrop_schedule .board .imgae {\n  width: 65px !important;\n  height: 65px !important;\n  object-fit: contain;\n}\n\n.newdraganddrop_schedule .next_previous button {\n  font-size: 22px;\n  padding: 10px;\n}\n.newdraganddrop_schedule .next_previous button.next-11 {\n  border-left: 1px solid rgb(229, 229, 234);\n}\n.newdraganddrop_schedule .react-select__indicator svg {\n  display: none !important;\n}\n.newdraganddrop_schedule\n  .react-select-container.form-select.css-b62m3t-container {\n  border: 1px solid rgb(229, 229, 234) !important;\n}\n\n.newdraganddrop_schedule .DatePicker {\n  height: 52px;\n}\n/* .newdraganddrop_schedule i.fa.fa-calendar-o {\n  position: absolute;\n  z-index: 1;\n  right: 37%;\n  top: 21%;\n} */\n/* .newdraganddrop_schedule .react-datepicker-popper {\n  position: absolute;\n  inset: 0px auto auto 0px;\n  transform: translate3d(90%, 30%, 0px) !important;\n} */\n\n/* Style for the dropdown container */\n.editdropdowntest {\n  position: relative;\n  display: inline-block;\n  z-index: 9;\n}\n\n/* Style for the dropdown button */\n.editdropdowntest-button {\n  /* background-color:  rgb(240, 240, 240) ; */\n  color: #000000;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n}\n\n/* Style for the dropdown menu */\n.editdropdowntest-menu {\n  display: none;\n  left: 25px;\n  top: 10px;\n  position: absolute;\n  background-color: #f9f9f9;\n  min-width: 100px;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n}\n\n/* Show the dropdown menu when the button is clicked */\n.editdropdowntest:hover .editdropdowntest-menu {\n  display: block;\n}\n\n/* Style for dropdown menu items */\n.editdropdowntest-menu a {\n  color: black;\n  padding: 5px;\n  text-decoration: none;\n  display: block;\n}\n\n/* Highlight dropdown menu items on hover */\n.editdropdowntest-menu a:hover {\n  background-color: #f1f1f1;\n  padding: 5px;\n}\n\n/* Style for the dropdown container */\n.editdropdownpage {\n  position: relative;\n  display: inline-block;\n}\n\n/* Style for the dropdown button */\n.editdropdownpage-button {\n  /* background-color:  rgb(240, 240, 240) ; */\n  color: #000000;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n}\n\n/* Style for the dropdown menu */\n.editdropdownpage-menu {\n  display: none;\n  left: -93px;\n  position: absolute;\n  background-color: #f9f9f9;\n  min-width: 100%;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n}\n\n/* Show the dropdown menu when the button is clicked */\n.editdropdownpage:hover .editdropdownpage-menu {\n  display: block;\n}\n\n/* Style for dropdown menu items */\n.editdropdownpage-menu a {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n\n/* Highlight dropdown menu items on hover */\n.editdropdownpage-menu a:hover {\n  background-color: #f1f1f1;\n}\n\n.commonActionPaddingcommonActionPadding {\n  padding: 5px;\n}\n\n.commonActionPaddingcommonActionPadding:hover {\n  background-color: #f1f1f1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
